import { ArrowDown } from 'lucide-react';
import { useSubscription } from '@rta/rta-blueprint-library';

import { ContentPanelMode, selectContentPanelMode, useAppSelector } from '@state';
import { Controller } from '@context';
import { ControllerFontSizeSupport } from './types';
import { Feature, FeatureHoookParams } from '..';
import { lang } from '@lang';
import { useDesign } from '@hooks';

type DecreaseFontSizeFeatureParams = FeatureHoookParams;
export const useDecreaseFontSizeFeature = (_params: DecreaseFontSizeFeatureParams = {}): Feature<number> => {
	const [controller] = useDesign<Controller, ControllerFontSizeSupport>();
	const contentMode: ContentPanelMode = useAppSelector(selectContentPanelMode);

	useSubscription(controller, false, [['designer-options-adjust-font-size', 'updated']]);

	const controllerSupportsFontSizeFeature = (controller?.options?.dimensions?.fontSizeFactor ?? null) !== null;
	const inThreeD = contentMode === ContentPanelMode.ThreeD;

	const font = controller && controllerSupportsFontSizeFeature ? controller.options.dimensions.fontSizeFactor : 0;

	return {
		name: 'decreaseFontSize',
		label: lang.fontSize.label.decrease,
		shortcut: '',
		tooltip: inThreeD ? lang.fontSize.tooltip.disabledInThreeDView : lang.fontSize.tooltip.decrease,
		icon: (props = {}) => <ArrowDown {...props} />,
		disabled: inThreeD || !controllerSupportsFontSizeFeature,
		value: font ?? 0,
		hidden: false,
		handler: () => {
			if (!inThreeD && controller && controllerSupportsFontSizeFeature) controller.options.dimensionFontSizeFactor -= 0.1;
		}
	};
};
